import styled from "@emotion/styled";
import bgUrl from "../../assets/images/cardBackground.png";
import {Link as RemixLink} from "../../elements/link";

export const CardBgImage = styled.img(() => ({
  position: "relative",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  objectFit: "cover",
}));

export const CardImage = styled.img(({theme}) => ({
  width: "100%",
  aspectRatio: theme?.breakpoints?.isMobile ? "320/240" : "326/300",
  height: "auto",
  marginBottom: theme?.breakpoints?.isMobile ? 10 : 17,
  objectFit: "cover",
  borderRadius: 12,
}));
export const DestinationImage = styled.img(({theme}) => ({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  objectPosition: "center",
}));

export const TextWrapper = styled.div(() => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
}));
export const Card = styled.div(({theme, isImg, designType = false, styles}) => ({
  position: "relative",
  display: "flex",
  height: "100%",
  boxSizing: "border-box",
  flexDirection: "column",
  padding: isImg ? "10px 10px 21px 10px" : 0,
  boxShadow: "0px 0px 32px 0px #1D314014",
  borderRadius: 16,
  backgroundColor:
    designType === "ad"
      ? "transparent "
      : designType === "blue"
        ? theme?.colors?.primaryBlue
        : theme?.colors?.primaryWhite,
  cursor: "pointer",
  border:
    designType === "blue-border" ? `1px solid ${theme?.colors?.borderBlue}` : "none",
  overflow: "hidden",
  transition: "box-shadow 0.3s ease",
  ":hover": {
    boxShadow: "0px 0px 32px 0px rgba(0, 0, 0, 0.2)",
    ".title": {
      color: designType === "blue" ? theme?.colors?.primaryWhite : theme?.colors?.black,
    },
  },
  ...styles,
}));
export const PushMailWrapper = styled.div(() => ({
  position: "relative",
  height: "100%",
  backgroundColor: "#F9F9F9",
}));
export const PushMailContainer = styled.div(({theme}) => ({
  marginTop: theme?.breakpoints?.xs
    ? 30
    : theme?.breakpoints?.sm
      ? "20%"
      : theme?.breakpoints?.xl
        ? 30
        : 49,
  paddingInline:
    theme?.breakpoints?.isMobile || theme?.breakpoints?.md
      ? 16
      : theme?.breakpoints?.xl
        ? 5
        : 16,
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
}));

export const LogoWrapper = styled.div(() => ({
  display: "flex",
  columnGap: 5,
  alignItems: "center",
  marginBottom: 16,
}));

export const LogoImg = styled.img(({theme}) => ({
  width: theme?.breakpoints?.xs ? 32 : theme?.breakpoints?.sm ? 50 : 32,
  height: theme?.breakpoints?.xs ? 32 : theme?.breakpoints?.sm ? 50 : 32,
}));

export const BibImg = styled.img(({theme}) => ({
  width: theme?.breakpoints?.isMobile ? "50%" : theme?.breakpoints?.md ? "55%" : 124,
  height: theme?.breakpoints?.isMobile ? "30" : theme?.breakpoints?.md ? "32%" : 86,
  position: "absolute",
  bottom: 0,
  right: 0,
}));
export const BgImage = styled.div(() => ({
  height: "100%",
  width: "100%",
  backgroundSize: "cover",
  backgroundImage: `url("${bgUrl}")`,
}));

export const ContentInnerWrapper = styled.div(() => ({
  display: "flex",
  position: "absolute",
  height: "100%",
  justifyContent: "space-between",
  flexDirection: "column",
  paddingInline: 8,
}));

export const ContentWrapper = styled.div(({styles}) => ({
  display: "flex",
  height: "100%",
  justifyContent: "center",
  flexDirection: "column",
  paddingInline: 8,
  ...styles,
}));

export const TopContentWrapper = styled.div(() => ({
  display: "flex",
  justifyContent: "space-between",
  marginBottom: 9,
}));

export const CardDate = styled.div(({theme, designType}) => ({
  fontSize: "0.75rem",
  lineHeight: 1.3,
  fontWeight: 400,
  fontFamily: theme?.font?.manrope,
  color:
    designType === "blue" ? theme?.colors?.primaryWhite : theme?.colors?.primaryBlack,
}));

export const CardType = styled.div(({theme, designType}) => ({
  fontSize: "0.75rem",
  lineHeight: 1.3,
  fontWeight: 400,
  fontFamily: theme?.font?.manrope,
  color:
    designType === "blue" ? theme?.colors?.brandLightBlue : theme?.colors?.primaryBlack,
}));

export const CardTheme = styled.div(({theme, textColor}) => ({
  position: "relative",
  width: "fit-content",
  fontSize: "0.75rem",
  lineHeight: 1.3,
  fontFamily: theme?.font?.manrope,
  fontWeight: 700,
  letterSpacing: "2%",
  color: theme?.colors[textColor],
  textDecoration: "none",
  ":hover": {
    ":after": {
      content: "''",
      position: "absolute",
      bottom: -3,
      left: 0,
      width: "0%",
      height: 2,
      backgroundColor: theme?.colors[textColor],
      WebkitClipPath: "polygon(0% 100%, 1% 0%, 100% 0%, 99% 100%)",
      clipPath: "polygon(0% 100%, 1% 0%, 100% 0%, 99% 100%)",
      animation: "underlineAnimation 0.3s forwards",
    },
  },
  "@keyframes underlineAnimation": {
    to: {
      width: "100%",
    },
  },
}));

export const StyledLink = styled(RemixLink)(({theme, color}) => ({
  textDecoration: "none",
  color: theme?.colors[color],
}));

export const TypeWrapper = styled.div(({color, borderColor}) => ({
  position: "absolute",
  top: 16,
  right: 16,
  height: 24,
  display: "flex",
  flexDirection: "row",
  gap: 2,
  alignItems: "center",
  justifyContent: "center",
  borderRadius: 8,
  paddingLeft: 4,
  paddingRight: 2,
  backgroundColor: color,
  border: `1px solid ${borderColor}`,
}));

export const TypeText = styled.div(({theme}) => ({
  fontSize: "1rem",
  lineHeight: 1.4,
  fontWeight: 400,
  fontFamily: theme?.font?.manrope,
  color: theme?.colors?.primaryWhite,
}));
